import { Avatar, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, getLocalValue, IsSmallScreen, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { IInfoColumns, WSInfocard } from "../../Components/View/WSInfocard";
import config from '../../Config/config.json';
import { WSIcons } from "../../commonFunctions/iIcons";
export const VendorProfileView: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const [vendorData, setVendorData] = useState<any>();
    const userId = getLocalValue(LoacalVariables.UserId);
    useEffect(() => {
        async function getDetails() {
            try {
                const response = await callAPI('VendorProfile/user', Method.GET, null, userId)
                setVendorData(response?.data)
            } catch (error) {

            }

        }
        getDetails()
    }, [])
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleIconClick = async () => {
     
            navigate(`/profile/edit/${vendorData?.userId}`)
        

    };

    const detailsColumns: IInfoColumns[] = [
        {

            fieldName: "name",
            type: "none",
            label: "Name",

        },
        {

            fieldName: "email",
            type: "none",
            label: "Email",

        },
         {

            fieldName: "phoneNumber",
            type: "none",
            label: "Phone",

        },
         {

            fieldName: "panNumber",
            type: "none",
            label: "PAN",

        },
          {

            fieldName: "websiteUrl",
            type: "none",
            label: "Website",

        },
          {

            fieldName: "address",
            type: "address",
            label: "Address",

        },

        //   {

        //     fieldName: "gstNumber",
        //     type: "none",
        //     label: "GST",

        // },
        //   {

        //     fieldName: "gstNumber",
        //     type: "none",
        //     label: "GST",

        // },
        

    ];
    const handleClick = () => {
        navigate('/doctor/add')
    }

    const transFormData = (data: any) => {
        if (data) {
            data.map((item: any) => {
                item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
            })
            return data
        }
    }
    const data: any = {
        fullName: 'Sishanglal'
    }
    return (
        <>
            <Grid sx={{ position: "relative", mt: 5 }}>
                {/* Card */}
                {vendorData && <Grid
                    sx={{
                        backgroundColor: "white",
                        borderRadius: 2,
                        p: 2,
                        boxShadow: 1,
                        mt: 0, // Give space for Avatar
                    }}
                >
                    {/* Avatar - half outside the top of the card */}
                    <Avatar
                        src={`${config.imgUrl}${vendorData?.profileImageUrl?.replace("UploadedImages/", "")}`}
                        alt="Profile"
                        sx={{
                            width: 80,
                            height: 80,
                            position: "absolute",
                            top: -40,
                            left: "50%",
                            transform: "translateX(-50%)",
                            border: "3px solid white",
                            overflow: "hidden",
                            '& img': {
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                // transform: 'scale(0.85)', // Zoom out effect
                                transformOrigin: 'center center',
                            },
                        }}
                    />


                    {/* Content below avatar */}
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        direction="column"
                        mt={4} // Space to push content below avatar
                    >
                        <Typography fontWeight="bold" sx={{ color: "#7D79C2", fontSize: "0.875rem" }}>
                            {getLocalValue(LoacalVariables.Name)}
                        </Typography>
                        {/* <Typography color="textSecondary">{`uiyuiyiiu`}</Typography> */}
                    </Grid>
                    <Grid
                        item container
                        spacing={2}>
                        <Grid sm={12} sx={{ padding: 2 }} mt={2}>
                            <WSInfocard column={detailsColumns} data={vendorData} header="Basic Information" onClick={handleIconClick}  buttonIcon={<WSIcons.Edit fontSize="small"  />}/>
                        </Grid>
                    </Grid>
                </Grid>
                }

            </Grid>

        </>
    )
})